import { render } from "./VehicleDialog.vue?vue&type=template&id=9aefb9d6&ts=true"
import script from "./VehicleDialog.ts?vue&type=script&lang=ts"
export * from "./VehicleDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__